// src/context/ToastContext.tsx
import React, { createContext, useContext, useRef } from "react";
import { Toast } from "primereact/toast";

type ToastFunc = (
  severity: "error" | "success" | "info" | "warn" | "secondary" | "contrast",
  summary: string,
  life?: number
) => void;

const ToastContext = createContext<ToastFunc>(() => {});

export const useToast = () => useContext(ToastContext);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const toastRef = useRef<any>(null);

  const toast: ToastFunc = (severity, summary, life = 3000) => {
    toastRef.current?.show({ severity, summary, life });
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <Toast
        ref={toastRef}
        appendTo={typeof document !== "undefined" ? document.body : undefined}
        style={{ zIndex: 2000 }}
      />
    </ToastContext.Provider>
  );
};
